import { DropdownMenuItem, DropdownMenuSeparator } from '@goaltree/ui/components/dropdown-menu'
import { MessageCircle } from 'lucide-react'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { useCoachCallMenu } from '@/components/coach-chat-sheet'
import type { CoachSheetRequest } from '@/lib/coach-call-store'

const open = (detail?: CoachSheetRequest) =>
  window.dispatchEvent(new CustomEvent('open-coach', { detail }))

// Long-press menu on the coach buttons: chat, then every kind of call.
export function CoachCallMenuItems({
  name,
  canVideo,
  onPick,
}: {
  name: string
  canVideo: boolean
  onPick?: () => void
}) {
  const { t } = useTranslation()
  const { talk, presets, extras } = useCoachCallMenu(canVideo)
  const item = (
    key: string,
    Icon: typeof MessageCircle,
    label: string,
    run: () => void,
    tip?: string,
  ) => (
    <DropdownMenuItem
      key={key}
      title={tip || undefined}
      onClick={() => {
        onPick?.()
        run()
      }}
      className="cursor-pointer gap-2.5 rounded-lg px-2.5 py-2 text-sm font-medium"
    >
      <Icon className="size-4 text-primary-text" />
      {label}
    </DropdownMenuItem>
  )
  return (
    <>
      {item('chat', MessageCircle, t('coachNav.chat', { name }), () => open())}
      {[talk, presets, extras].map((group, i) => (
        <Fragment key={i}>
          <DropdownMenuSeparator />
          {group.map(({ icon, label, desc, req }) =>
            item(label, icon, label, () => open({ startCall: true, ...req }), desc),
          )}
        </Fragment>
      ))}
    </>
  )
}
